import React from "react";

import { useFilterListProps } from "@usereactify/search";

type FiltersBoxProps = {
  filterListProps: ReturnType<typeof useFilterListProps>;
  isSizeGuide: boolean;
  setFilterOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FiltersBox: React.FC<FiltersBoxProps> = (props) => {
  const { filterListProps, isSizeGuide, setFilterOpen } = props;

  const handleFilterChange = (val: string) => {
    filterListProps.handleChange(val);
    setFilterOpen(false);
  };

  // Render a generic FiltersBox
  if (!isSizeGuide) {
    return (
      <>
        {filterListProps.options.map((option) => (
          <>
            <Box option={option} value={filterListProps.value} handleChange={handleFilterChange} />
          </>
        ))}
      </>
    );
  }

  // For size guides, split the sections into 2 columns, tops and bottoms
  // check if the keys are only digits to determine if they are a top or bottom size
  const isNumber = /^[0-9]+$/;
  const sections = [
    { name: "Tops", data: filterListProps.options.filter((opt) => !opt.key.match(isNumber)) },
    { name: "Bottoms", data: filterListProps.options.filter((opt) => opt.key.match(isNumber)) },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      {sections.map(({ name, data }) => (
        <div className="pb-4 md:pb-0">
          <h4 className="mb-4 font-body text-body">{name}</h4>
          <ul className={`block ${name === "Tops" ? "md:w-32" : ""}`}>
            {data.map((option) => (
              <Box option={option} value={filterListProps.value} handleChange={handleFilterChange} />
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

type BoxProps = {
  option: {
    checked: boolean;
    doc_count: number;
    key: string;
  };
  value:
    | string
    | {
        [key: string]: boolean;
      };
  handleChange: (val: string) => void;
};

const Box: React.FC<BoxProps> = ({ option, value, handleChange }) => {
  const classes = () => `${option.checked ? "bg-med-grey" : "bg-light-grey"} tag__checkbox-wrapper text-label`;

  return (
    <li key={option.key} className="tag">
      <label className={classes()}>
        <input
          type="checkbox"
          className="hidden tag__input"
          key={option.key?.toString()}
          value={option.key}
          checked={option.checked}
          onChange={() => handleChange(option.key)}
        />
        <span className="tag__checkbox"></span>
        <span>
          <span className="tag__text">{option.key}</span>
        </span>
      </label>
    </li>
  );
};
